import { Link } from "react-router-dom";
import { Clock, Star } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { fileUrl } from "@/lib/api";
import { formatRands } from "@/lib/order";

export function VendorCard({ vendor }) {
  return (
    <Link to={`/store/${vendor.vendor_id}`} data-testid={`vendor-card-${vendor.vendor_id}`}>
      <Card className="group overflow-hidden rounded-2xl border-2 transition-all hover:-translate-y-1 hover:shadow-pop-sm">
        <div className="relative h-36 w-full overflow-hidden bg-muted">
          {vendor.banner_url ? (
            <img
              src={fileUrl(vendor.banner_url)}
              alt={vendor.name}
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="checker checker-blue checker-sm h-full w-full opacity-80" />
          )}
          <Badge className="absolute left-3 top-3 rounded-full border-transparent bg-popyellow font-display font-medium text-foreground">
            {vendor.category}
          </Badge>
        </div>
        <div className="p-4">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-display text-base leading-tight">{vendor.name}</h3>
            <span className="flex items-center gap-1 text-sm text-foreground">
              <Star className="h-3.5 w-3.5 fill-[hsl(var(--warning))] text-[hsl(var(--warning))]" />
              {(vendor.rating ?? 0).toFixed(1)}
            </span>
          </div>
          {vendor.description && (
            <p className="mt-1 line-clamp-1 text-sm text-muted-foreground">{vendor.description}</p>
          )}
          <div className="mt-3 flex items-center gap-4 text-xs text-muted-foreground">
            <span className="flex items-center gap-1">
              <Clock className="h-3.5 w-3.5" /> {vendor.eta_minutes ?? 30} min
            </span>
            <span>{formatRands(vendor.delivery_fee_base)} delivery</span>
          </div>
        </div>
      </Card>
    </Link>
  );
}
